import { UnderwritingActivitySearchParams } from '@lio/api-types';

export const queryKeys = {
  underwritingActivity: 'underwriting-activity' as const,
  underwritingActivitySearchWithParams: (params: UnderwritingActivitySearchParams) =>
    [queryKeys.underwritingActivity, params] as const,
  underwritingActivityType: 'underwriting-activity-type',
};
